/**
 * Early-Bird A/B Test — sticky variant assignment + reveal.
 * Test key: early_bird_test_v1 | Variants: a (control), b (scarcity+steps).
 * Applies to ALL viewports, 50/50. Reveal = data-eb-variant on .early-bird.
 * No-JS / pre-JS default is Variant A (CSS hides .eb-b) — so this only ever
 * *promotes* a user to B; it never blanks the section.
 */
(function () {
  'use strict';

  var CONFIG = {
    testName: 'early_bird_test_v1',
    split: 0.5,                       // P(variant 'a'); 0.5 = 50/50
    storageKey: 'memoket_ab_early_bird',
    urlParam: 'eb_variant'
  };

  function isVariant(v) { return v === 'a' || v === 'b'; }

  function readOverride() {
    try {
      var v = new URLSearchParams(window.location.search).get(CONFIG.urlParam);
      return isVariant(v) ? v : null;          // QA override — not persisted
    } catch (e) { return null; }
  }

  function readStored() {
    try {
      var data = JSON.parse(localStorage.getItem(CONFIG.storageKey));
      return data && isVariant(data.variant) ? data.variant : null;
    } catch (e) { return null; }
  }

  function persist(variant) {
    try {
      localStorage.setItem(CONFIG.storageKey, JSON.stringify({
        variant: variant, testName: CONFIG.testName, assignedAt: new Date().toISOString()
      }));
    } catch (e) { /* storage blocked — in-memory only for this view */ }
  }

  function assign() {
    var override = readOverride();
    if (override) return override;
    var stored = readStored();
    if (stored) return stored;
    var variant = Math.random() < CONFIG.split ? 'a' : 'b';
    persist(variant);
    return variant;
  }

  var variant = assign();

  // Expose for theme.js (checkout attrs) + analytics-enhanced.js (auto-tagging)
  window.__MEMOKET_AB = window.__MEMOKET_AB || {};
  window.__MEMOKET_AB[CONFIG.testName] = variant;

  function reveal() {
    var nodes = document.querySelectorAll('.early-bird');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute('data-eb-variant', variant);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }

  // Report the assignment once, deferred so analytics SDKs are ready.
  // Mirrors ab-test.js; every call is wrapped so analytics can never break the page.
  function reportImpression() {
    if (typeof gtag === 'function') {
      try {
        gtag('set', 'user_properties', { ab_early_bird_variant: variant });
        gtag('event', 'experiment_impression', { experiment_id: CONFIG.testName, variant_id: variant });
      } catch (e) {}
    }
    if (typeof fbq === 'function') {
      try { fbq('trackCustom', 'ABTestAssigned', { test_name: CONFIG.testName, variant: variant }); } catch (e) {}
    }
    if (window.ptengine && typeof window.ptengine.track === 'function') {
      try { window.ptengine.track('ab_variant_assigned', { test_name: CONFIG.testName, variant: variant }); } catch (e) {}
    } else if (window.MemoketAnalytics && typeof window.MemoketAnalytics.sendToPtengine === 'function') {
      try { window.MemoketAnalytics.sendToPtengine('ab_variant_assigned', { test_name: CONFIG.testName, variant: variant }); } catch (e) {}
    }
    if (window._learnq) {
      try { window._learnq.push(['identify', { ab_early_bird_variant: variant, ab_test_name: CONFIG.testName }]); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reportImpression);
  } else {
    setTimeout(reportImpression, 100);
  }

  // Exposed for tests.
  window.__MEMOKET_AB.__earlyBird = { config: CONFIG, variant: variant };
})();
